<template>
     <vs-dialog prevent-close v-model="active" width="800px">
        <template #header>
          <h4 class="not-margin">
              Enviar {{tipo.texto}}
          </h4>
        </template>
        <div class="con-form">
            <h5>Se enviará la {{tipo.texto}} a los siguientes destinatarios.</h5>
            <div>
                <vs-table>
                    <template #thead>
                    <vs-tr>
                        <vs-th>
                            Nombre
                        </vs-th>
                        <vs-th>
                            Código de detalle
                        </vs-th>
                        <vs-th>
                            Saldo pendiente
                        </vs-th>
                    </vs-tr>
                    </template>
                    <template #tbody>
                    <vs-tr
                        :key="i"
                        v-for="(tr, i) in vencidas.personas"
                        :data="tr"
                        :class="vencidas.personas.length > 1 ? 'dividerLine' : ''"
                    >
                        <vs-td>
                            <p class="mb-0"><small>Nombre</small></p>
                            <p><strong>{{tr.nombre}}</strong></p>
                            <p class="mb-0"><small>Matrícula</small></p>
                            <p><strong>{{tr.matricula}}</strong></p>
                        </vs-td>
                        <vs-td>
                            <div class="trecientos" v-for="info in tr.cargos" :key="info.id" >
                                <p v-if="info.fecha.vencida == true"> {{ info.codigoDetalle }} </p>
                            </div>
                        </vs-td>
                        <vs-td>
                            <div class="cien" v-for="info in tr.cargos" :key="info.id">
                                <p v-if="info.fecha.vencida == true"> {{ info.saldoPendiente | currency }}</p>
                            </div>
                        </vs-td>
                    </vs-tr>
                    </template>
                </vs-table>
            </div>
        </div>
        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        danger
                        flat
                        @click="active = false">
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        class="ml-auto"
                        @click="getEnviarCartas()">
                        Enviar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
</template>

<script>
import reportes from '../../../../../api/requests/reportes.js'
export default {
    props:[
      'value',
      'vencidas',
      'tipo'
    ],
    data () {
        return {
            active: false,
        }
    },
    methods: {
        async getEnviarCartas(){
            const loading = this.$vs.loading()
            try{
                const params = {
                    "personas_ids": this.vencidas.personas_ids,
                    "tipo_notificacion": this.tipo.tipo,
                    "institucion_id": this.vencidas.institucion,
                    "ciclo_escolar_id": this.vencidas.ciclo_escolar
                }
            
                const {data: response} = await reportes.getEnviarCartas(params)
                loading.close()
                this.active = false
                const datos = Object.values(response.personas_sin_registro)
                if(datos[0]){
                    this.$emit('sinRegistro', datos)
                }else{
                    this.$vs.notification({
                    icon: '<i class="fas fa-check"></i>',
                    sticky: true,
                    duration: '6000',
                    color: 'success',
                    position: null,
                    title: 'Se envio con éxito la(s) carta(s)'
                    })
                }
            } catch (error) {
                loading.close()
                console.log(error)
                this.$vs.notification({
                color: 'danger',
                position: null,
                title: 'Algo salio mal, favor de contactar al administrador '
                })
            }
            
        }
     },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>
<style scoped>

.dividerLine {
  width: 100%;
  border-bottom: 1px solid #ddd
}
</style>